import React from 'react';
import { Link } from 'react-router-dom';
import BlogPagination from "../../components/blog/BlogPagination";

const EventGrid = () => {
  return (
    <>
      <section className="services-icon ptb-120">
        <div className="container">
          <div className="row justify-content-center">
            <div className="col-lg-4 col-md-6 p-0">
              <div className="single-service p-lg-5 p-4 text-center">
                <div className="service-icon icon-center">
                  <Link>
                    <img
                        src="assets/img/EventPage_ICE_London_Logo_300x150_20240110.png"
                    />
                  </Link>
                </div>
              </div>
            </div>
            <div className="col-lg-4 col-md-6 p-0">
              <div className="single-service p-lg-5 p-4 text-center">
                <div className="service-icon icon-center">
                  <Link>
                    <img
                        src="assets/img/EventPage_SBCSUMMIT_Rio_Logo_20250214.png"
                    />
                  </Link>
                </div>
              </div>
            </div>
            <div className="col-lg-4 col-md-6 p-0">
              <div className="single-service p-lg-5 p-4 text-center">
                <div className="service-icon icon-center">
                  <Link>
                    <img
                        src="assets/img/ITB_Berlin_Logo_W300-1.png"
                    />
                  </Link>
                </div>
              </div>
            </div>
            <div className="col-lg-4 col-md-6 p-0">
              <div className="single-service p-lg-5 p-4 text-center">
                <div className="service-icon icon-center">
                  <Link>
                    <img
                        src="assets/img/EventPage_MPE_Berlin_Logo_300x150_20240109.png"
                    />
                  </Link>
                </div>
              </div>
            </div>
            <div className="col-lg-4 col-md-6 p-0">
              <div className="single-service p-lg-5 p-4 text-center">
                <div className="service-icon icon-center">
                  <Link>
                    <img
                        src="assets/img/EventPage_SiGMAAmericas_Logo_2025.png"
                    />
                  </Link>
                </div>
              </div>
            </div>
            <div className="col-lg-4 col-md-6 p-0">
              <div className="single-service p-lg-5 p-4 text-center">
                <div className="service-icon icon-center">
                  <Link>
                    <img
                        src="assets/img/EventPage_BlockchainWeek_Paris_Logo_300x150_2024.png"
                    />
                  </Link>
                </div>
              </div>
            </div>
            <div className="col-lg-4 col-md-6 p-0">
              <div className="single-service p-lg-5 p-4 text-center">
                <div className="service-icon icon-center">
                  <Link>
                    <img
                        src="assets/img/Token_Dubai_2024_logo_W300px.png"
                    />
                  </Link>
                </div>
              </div>
            </div>
            <div className="col-lg-4 col-md-6 p-0">
              <div className="single-service p-lg-5 p-4 text-center">
                <div className="service-icon icon-center">
                  <Link>
                    <img
                        src="assets/img/EventPage_ITTConference_Logo_2025.png"
                    />
                  </Link>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default EventGrid;
